var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex", attrs: { id: "clients" } }, [
    _c(
      "div",
      { staticClass: "flex flex-col flex-grow" },
      [
        _c(
          "div",
          {
            staticClass:
              "sticky left-0 z-50 flex items-center justify-between h-20 gap-4 px-6 border-b top-18 bg-slate-200 border-slate-400",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          [
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4" },
                  [
                    _c("BlTextTitle4", { attrs: { text: "Clients" } }),
                    _vm._v(" "),
                    _c("BlBubbleCount", {
                      attrs: { count: _vm.totalClients || 0 }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: { text: "View and organize your list of clients." }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _vm.currentUser && _vm.currentUser.role.includes("admin")
                  ? _c("BlInputButton", {
                      attrs: { type: "outlined", label: "Assign therapist" },
                      on: { clicked: _vm.onOpenAssignTherapist }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: { icon: "plus", label: "New client" },
                  on: {
                    clicked: function($event) {
                      _vm.newClientOpened = true
                    }
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm.newClientOpened
          ? _c("NewClientModal", {
              on: {
                "close-modal": function($event) {
                  _vm.newClientOpened = false
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.assignTherapistOpened
          ? _c(
              "BlBackdrop",
              {
                attrs: {
                  title: "Assign therapist",
                  description:
                    "Manage and assign clients to specific therapists.",
                  label: "Update",
                  disabled: !_vm.verifiedAssignTherapistInput,
                  submitLoading: _vm.assignTherapistLoading
                },
                on: {
                  "backdrop-close": _vm.onCancelAssignTherapist,
                  "backdrop-action": _vm.onAsignTherapist
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col gap-4 px-4 lg:px-8",
                    style: { width: "40rem" }
                  },
                  [
                    _c("BlSearchSelect", {
                      attrs: {
                        label: "Client's name",
                        asterisk: "",
                        placeholder: "Find your client's name",
                        fetchProperty: {
                          url:
                            "/api/v1/clients?sort=alphabetical&status=active&query=",
                          dataKey: "clients",
                          countKey: "total_clients",
                          optionKeys: { value: "id", label: "name" }
                        }
                      },
                      on: { change: _vm.onChangeClient },
                      model: {
                        value: _vm.assignTherapistInput.id,
                        callback: function($$v) {
                          _vm.$set(_vm.assignTherapistInput, "id", $$v)
                        },
                        expression: "assignTherapistInput.id"
                      }
                    }),
                    _vm._v(" "),
                    _c("BlSearchBox", {
                      key: "multi-select-assign-" + _vm.assignTherapistInput.id,
                      attrs: {
                        type: "user",
                        label: "Assign to",
                        placeholder: "Type your therapist's name",
                        options: _vm.assignTherapistInput.existingUsers.map(
                          function(i) {
                            return {
                              value: i.id,
                              label: i.name
                            }
                          }
                        ),
                        disabled: !_vm.assignTherapistInput.id,
                        fetchProperty: {
                          url:
                            "/api/v1/users?sort=name_asc&status=active&query=",
                          dataKey: "users",
                          countKey: "total_users",
                          optionKeys: { value: "id", label: "name" }
                        }
                      },
                      on: {
                        change: function($event) {
                          _vm.assignTherapistInput.userIds = $event
                        }
                      },
                      model: {
                        value: _vm.assignTherapistInput.userIds,
                        callback: function($$v) {
                          _vm.$set(_vm.assignTherapistInput, "userIds", $$v)
                        },
                        expression: "assignTherapistInput.userIds"
                      }
                    }),
                    _vm._v(" "),
                    _vm.diffAssignTherapistCount > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-start gap-2 px-3 py-2 text-sm rounded bg-pending-100 text-pending"
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "flex-shrink-0 w-6",
                              attrs: { icon: "warning", color: "pending" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "flex-wrap" }, [
                              _vm._v(
                                "\n            You are about to remove\n            " +
                                  _vm._s(_vm.diffAssignTherapistCount) +
                                  " therapist(s) from this client.\n            "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n            Once removed, they will no longer have access to this client's\n            information.\n            "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n            Don't worry, you can always assign them again in the future.\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sticky left-0 z-30 flex items-center gap-2 px-6 py-3 mb-3 border-b border-slate-400",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          [
            _c("BlInputSearch", {
              staticClass: "w-80",
              attrs: { input: _vm.searchInput },
              on: { changed: _vm.onInputSearch }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-40" },
              [
                _c("BlInputFilter", {
                  attrs: { input: _vm.filterInput },
                  on: { changed: _vm.onChangeFilter }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("BlInputSelect", {
              staticClass: "w-60",
              attrs: { input: _vm.sortInput },
              on: { changed: _vm.onChangeFilter }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "px-4 mb-4 bl-clients-body lg:mb-8 lg:px-6",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          [
            _vm.pageLoading
              ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                  _c("div", { staticClass: "blum-loader" })
                ])
              : !_vm.clients.length
              ? _c(
                  "div",
                  { staticClass: "grid h-128 place-items-center" },
                  [_c("BlTextBody1", { attrs: { text: "Client not found." } })],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4"
                  },
                  _vm._l(_vm.clients, function(client) {
                    return _c(
                      "div",
                      { key: client.id, staticClass: "bl-client" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/clients/" + client.id } },
                          [
                            _c("div", { staticClass: "bl-client-header" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bl-client-header-avatar-container"
                                },
                                [
                                  _c("Avatar", {
                                    attrs: {
                                      name: client.name,
                                      status: client.status
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bl-client-header-detail-container"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center gap-2 pr-4"
                                    },
                                    [
                                      _c("BlTextSubtitle2", {
                                        staticClass:
                                          "truncate bl-client-header-name",
                                        attrs: { text: client.name }
                                      }),
                                      _vm._v(" "),
                                      client.is_new
                                        ? _c(
                                            "div",
                                            { staticClass: "ml-auto" },
                                            [
                                              _c("BlTextBody2", {
                                                staticClass:
                                                  "px-3 py-1 rounded-full text-slate-100 bg-success-400",
                                                attrs: { text: "New" }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bl-client-header-birthday"
                                    },
                                    [
                                      _c("BlIcon", {
                                        staticClass:
                                          "bl-client-header-birthday-icon",
                                        attrs: { icon: "cake" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text: _vm.getDateWithoutTimezone(
                                            client.birthday
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "bl-client-body" },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "bl-client-note",
                                  attrs: {
                                    text:
                                      client.status === "active"
                                        ? client.note
                                        : client.status === "archived"
                                        ? "Discharged on " +
                                          _vm.getDateWithoutTimezone(
                                            client.archived_at
                                          )
                                        : "At risk of discharge"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-col gap-4 bl-client-footer"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap gap-4" },
                              _vm._l(client.accesses, function(access) {
                                return _c(
                                  "div",
                                  {
                                    key: access.id,
                                    style: { maxWidth: "50%" }
                                  },
                                  [
                                    access.user_id &&
                                    access.user &&
                                    access.user.name
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "flex flex-wrap items-center px-2 truncate border rounded h-7 bg-success-100 border-success-100",
                                            class: [
                                              _vm.currentUser.role.includes(
                                                "admin"
                                              )
                                                ? "hover:border-success-400"
                                                : "cursor-default"
                                            ],
                                            attrs: {
                                              event: _vm.currentUser.role.includes(
                                                "admin"
                                              )
                                                ? "click"
                                                : "",
                                              target: "_blank",
                                              to: {
                                                name: "TeamSessionHistory",
                                                params: {
                                                  user_id: access.user_id,
                                                  redirect_target: "/clients",
                                                  redirect_label: "Clients"
                                                }
                                              },
                                              title: access.user.name
                                            }
                                          },
                                          [
                                            _c("BlTextBody2", {
                                              staticClass:
                                                "truncate text-success",
                                              attrs: { text: access.user.name }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap gap-4" },
                              [
                                _vm._l(client.branches, function(branch) {
                                  return _vm.enableBranch
                                    ? _c(
                                        "div",
                                        {
                                          key: branch.id,
                                          staticClass:
                                            "flex items-center justify-center px-2 truncate rounded h-7",
                                          style: {
                                            backgroundColor:
                                              branch.background_color ||
                                              "unset",
                                            maxWidth: "50%"
                                          }
                                        },
                                        [
                                          _c("BlTextBody2", {
                                            staticClass: "truncate",
                                            style: {
                                              color: branch.color || "unset"
                                            },
                                            attrs: { text: branch.name || "-" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm._l(client.tags, function(tag) {
                                  return _c(
                                    "div",
                                    {
                                      key: tag.id,
                                      staticClass:
                                        "flex items-center justify-center px-2 truncate rounded h-7 bg-slate-300",
                                      style: { maxWidth: "50%" }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass:
                                          "truncate whitespace-no-wrap text-slate-800",
                                        attrs: { text: tag.name || "-" }
                                      })
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
          ]
        ),
        _vm._v(" "),
        _vm.totalClients > 20
          ? _c(
              "div",
              { staticClass: "mb-4 lg:mb-8" },
              [
                _c("BlInputPagination", {
                  attrs: {
                    count: Math.ceil(
                      _vm.totalClients / (_vm.$route.query["per_page"] || 20)
                    ),
                    page: _vm.page
                  },
                  on: { changed: _vm.changePage }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-140a8281", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-140a8281","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/Clients.vue
// module id = null
// module chunks = 